export default mods => {
    if(!window.$bonelibs){
        window.$bonelibs = {};
    }

    Object.keys(mods).forEach(modName => {
        if(window.$bonelibs[modName]){
            if(document.currentScript){
                console.warn(`${modName}重复引用，from:${document.currentScript.src}`);
            }else{
                console.warn(`${modName}重复引用`);
            }
        }
    });

    Object.assign(window.$bonelibs, mods);
}


// WEBPACK FOOTER //
// ./utils/export.js